import { Fragment, useState } from "react";
import { Box } from "@mui/material";
import { Button, Card, Input, Textarea } from "@material-tailwind/react";

const Header = ({ title, description, setTitle, setDescription }) => {
  const [isEditingTitle, setIsEditingTitle] = useState(false);
  const [isEditingDescription, setIsEditingDescription] = useState(false);

  return (
    <Fragment>
      <div className="container mx-auto">
        <Card className="p-6">
          <Box sx={{ mb: 3 }}>
            {isEditingTitle ? (
              <div className="flex justify-between items-center gap-2 mb-2">
                <Input
                  type="text"
                  size="lg"
                  value={title}
                  onBlur={() => setIsEditingTitle(false)}
                  onChange={(e) => setTitle(e.target.value)}
                  variant="outlined"
                  className="border border-gray-500"
                  placeholder="Form Title"
                  name="title"
                  fullWidth
                  autoFocus
                />
              </div>
            ) : (
              <div className="flex justify-between items-center">
                <h1
                  onClick={() => setIsEditingTitle(true)}
                  className="text-md cursor-pointer"
                >
                  {title}
                </h1>
                <Button size="sm" onClick={() => setIsEditingTitle(true)}>
                  Edit
                </Button>
              </div>
            )}
            {isEditingDescription ? (
              <Textarea
                size="lg"
                value={description}
                onBlur={() => setIsEditingDescription(false)}
                onChange={(e) => setDescription(e.target.value)}
                variant="outlined"
                rows={3}
                placeholder="Form Description"
                className="mb-2 border px-3 my-2 py-2 border-gray-500 rounded-sm"
                name="description"
                fullWidth
                autoFocus
              />
            ) : (
              <>
                {description ? (
                  <p
                    onClick={() => setIsEditingDescription(true)}
                    className="cursor-pointer"
                  >
                    {description}
                  </p>
                ) : (
                  <Button
                    variant="outlined"
                    size="sm"
                    onClick={() => setIsEditingDescription(true)}
                  >
                    + Add Description
                  </Button>
                )}
              </>
            )}
          </Box>
        </Card>
      </div>
    </Fragment>
  );
};

export default Header;
